import styles from './FileIndicator.scss';

const statusStyle = {
    standard: {
        link: styles.standard__link,
        icon: styles.standard__icon,
        title: styles.standard__title
    },
    warning: {
        link: styles.warning__link,
        icon: styles.warning__icon,
        title: styles.warning__title
    }
};
function setTitle(title, failedConversion, hasDuplicate) {
    if(failedConversion && hasDuplicate) {
        return `Document Issue - ${title}`;
    }
    if(failedConversion){
        return `Conversion Failure - ${title}`;
    }
    if(hasDuplicate) {
        return `Duplicate - ${title}`;
    }

    return title;
}

export default function FileIndicator({title, hasDuplicate, failedConversion, onClick}) {
    const invalidDocument = failedConversion || hasDuplicate ;
    const indicatorStyle = invalidDocument? statusStyle.warning : statusStyle.standard;

    return (
        <div className={indicatorStyle.link} onClick={onClick} data-cy="FileIndicatorBtn">
            <i className={indicatorStyle.icon} />
            <span className={indicatorStyle.title} data-cy="FileIndicator-title">{setTitle(title, failedConversion, hasDuplicate)}</span>
        </div>
    );
}
